import { render, staticRenderFns } from "./safeTable.vue?vue&type=template&id=18201fc4&scoped=true"
import script from "./safeTable.vue?vue&type=script&lang=js"
export * from "./safeTable.vue?vue&type=script&lang=js"
import style0 from "./safeTable.vue?vue&type=style&index=0&id=18201fc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18201fc4",
  null
  
)

export default component.exports